import React, { FunctionComponent, ReactNode } from "react";

type Props = {
  children: ReactNode;
  wrapper: FunctionComponent<{ children: ReactNode }>;
  condition: boolean;
};

/**
 * Conditionally wrapps children with a component. If conditions are not met children mounted without the wrapper.
 */
export const ConditionalWrapperBS: FunctionComponent<Props> = ({ condition, children, wrapper: Wrapper }) =>
  condition ? <Wrapper>{children}</Wrapper> : <>{children}</>;
